<div class="login-form-content">
  <form class="login-form m-auto">
    <h4 class="text-center mb-5 form-heading">{{'Please Wait' | translate}}...</h4>
    <div class="description">
      <p>
        {{'There is some processing going on with this loan, kindly wait for a few min(s) till the processing completes' | translate}}.
        {{'Thanks for your patience' | translate}}!
      </p>
    </div>
    <div class="row text-justify">
      <div class="col-md-6 text-start">
        <a [href]="queuesUrl">{{'Queue' | translate}}</a>
      </div>
      <div class="col-md-6 text-end">
        <a [href]="refreshUrl">{{'Refresh' | translate}}</a>
      </div>
      <!-- <div class="col-md-4 text-end">
        <a [href]="nextUrl" [class.inactiveLink]="!showNext">Next</a>
      </div> -->
    </div>
  </form>
</div>
